<template>
  <div v-show="isLoadEnd" class="page">
    <div class="head-cell">
      <img class="head" @click="onCopy" :src="userFace" />
      <div class="center">
        <p>{{ userName }}</p>
        <!-- <p>关注商家抖音号，获取更多惊喜></p> -->
      </div>
      <div @click="onOpenCoupon" class="but">我的优惠券</div>
    </div>
    <div v-if="task_status == 2 || isCoupon" class="but-cell">
      <div class="but" @click="onPublish">
        {{
          isCoupon
            ? "查看优惠券"
            : video_source_type == 2
            ? "立即领取"
            : "立即拍视频"
        }}
      </div>
    </div>
    <div class="no-start" v-else>
      <p>抱歉！</p>
      <p>活动暂未开始</p>
    </div>
    <div
      class="scroll-box"
      v-if="(task_status == 2 || isCoupon) && topList.length > 4"
    >
      <transition name="slide" mode="out-in">
        <div class="item" :key="'id_' + getCouponUserInfo.userId">
          <span style="color: #eb3329">{{ getCouponUserInfo.userName }}</span>
          <span>刚刚发布了视频，已领取奖励</span>
        </div>
      </transition>
    </div>
    <div class="line"></div>
    <div class="title">
      {{ task_name }}
    </div>
    <div class="desc" v-html="task_desc"></div>
    <div :class="['dialog', isDialog ? '' : 'dialog-hide']">
      <div class="content">
        <div class="coupon-info">
          <div v-if="couponInfo.type == 1" class="money">
            <span class="unit">￥</span>{{ couponInfo.discountMoney }}
          </div>
          <div v-else class="money">
            {{ couponInfo.discountMoney }}<span class="unit">折</span>
          </div>
          <div class="right-cell">
            <div class="coupon-name">
              {{ couponInfo.name }}
            </div>
            <div class="coupon-desc">
              {{
                couponInfo.orderLimitMoney == 0
                  ? "无门槛"
                  : "满" + couponInfo.orderLimitMoney + "可用"
              }}
            </div>
          </div>
        </div>
        <div @click="onOpenCoupon" class="but">去使用</div>
        <img
          class="colse"
          @click="onColse"
          src="../../assets/images/popularize/close.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "api";
import httpConfig from "../../config/http";
import { Toast, Indicator } from "mint-ui";
const totalDuration = 3000; //停顿的时间
export default {
  data: () => {
    return {
      isLoadEnd: false, //是否加载完成
      id: "", //活动id
      business_id: "", //商家id
      userName: "", //商家名字
      userFace: "", //商家头像
      task_name: "", //活动名字
      task_desc: "", //活动简介
      video_source_type: "1", //视频来源类型 1-指定视频 2-素材随机推荐
      isCoupon: false, //是否领取优惠券
      couponInfo: {}, //优惠券信息
      topList: [],
      task_status: 1, //活动状态，1未开始，2已开始
      number: 0,
      isDialog: false, //是否显示领取
    };
  },
  created() {
    document.title = "有惊喜等你！";
    sessionStorage.setItem("session_id", this.$route.query.session_id);
    Indicator.open({
      text: "加载中...",
      spinnerType: "fading-circle",
    });
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
    this.getUserCouponList();
  },
  //设置计算属性
  computed: {
    getCouponUserInfo() {
      return this.topList[this.number];
    },
  },
  methods: {
    startMove() {
      let timer = setTimeout(() => {
        if (this.number === this.topList.length - 1) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        clearTimeout(timer);
        this.startMove();
      }, totalDuration);
    },
    onOpenCoupon() {
      window.location.href = `${
        httpConfig.urlHost
      }coupon-list?platform=kuaishou&id=${this.id}&session_id=${
        sessionStorage.session_id || ""
      }&business_id=${this.business_id}`;
    },
    /**
     * 获取详情
     */
    getDetail() {
      api.request("getHotVideoDetail", { id: this.id }).then((res) => {
        if (res.status === 0) {
          this.business_id = res.data.business_id || "";
          this.userName = res.data.userName;
          this.userFace = res.data.userFace;
          this.task_name = res.data.task_name;
          this.task_desc = res.data.task_desc;
          this.video_source_type = res.data.video_source_type;
          this.task_status = res.data.task_status;
          this.couponInfo =
            res.data.coupon_list.length > 0 ? res.data.coupon_list[0] : [];
          if (window._isVideoPublishSucceed) {
            delete window._isVideoPublishSucceed;
            this.isDialog = true;
          }
          this.$nextTick(() => {
            this.isLoadEnd = true;
            Indicator.close();
          });
        }
      });
    },
    /**
     * 获取最近领取优惠券的列表
     */
    getUserCouponList() {
      api
        .request("getHotVideoUserCouponList", { taskId: this.id, top: 10 })
        .then((res) => {
          if (res.status === 0) {
            this.topList = res.data.topList;
            this.isCoupon = res.data.mylist.length > 0;
            if (this.topList.length > 4) {
              this.startMove();
            }
          }
        });
    },
    /**
     * 发布视频
     */
    onPublish() {
      if (this.isCoupon) {
        this.onOpenCoupon();
        return;
      }
      if (this.video_source_type == 2 /** 立即领取 */) {
        api.request("getHotVideoPublish", { id: this.id }).then((res) => {
          if (res.data.errorCode === 0) {
            this.isDialog = true;
          } else {
            Toast(res.data.msg);
          }
        });
      } else {
        this.$router.push({
          path: "/popularize/publish",
          query: {
            id: this.id,
          },
        });
      }
    },
    onCopy() {
      // this.copyFn(window.location.href);
    },
    copyFn(val) {
      // createElement() 方法通过指定名称创建一个元素
      var copyInput = document.createElement("input");
      //val是要复制的内容
      copyInput.setAttribute("value", val);
      document.body.appendChild(copyInput);
      copyInput.select();
      try {
        var copyed = document.execCommand("copy");
        if (copyed) {
          document.body.removeChild(copyInput);
          Toast("复制成功");
        }
      } catch {
        console.log("复制失败，请检查浏览器兼容");
      }
    },
    /**
     * 关闭弹框
     */
    onColse() {
      this.isDialog = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.page
  background: rgba(255, 238, 226, 0.39)
  height: 100vh
  display: flex
  flex-flow: column
  align-items: center
  overflow-y: scroll
  .head-cell
    display: flex
    flex-flow: row nowrap
    align-items: center
    padding: 43px 0
    width: 100%
    background: rgba(255, 255, 255, 0.39)
    flex-shrink: 0
    .head
      width: 92px
      height: 92px
      margin-left: 35px
      flex-shrink: 0
      margin-right: 16px
      border-radius: 8px

    .center
      flex-grow: 1
      p:nth-child(1)
        font-size: 28px
        font-weight: bold
        color: #353535
      p:nth-child(2)
        font-size: 24px
        color: #faab0c
    .but
      width: 200px
      height: 64px
      border: 2px solid #eb3329
      border-radius: 64px
      line-height: 64px
      color: #eb3329
      font-size: 26px
      text-align: center
      margin-right: 30px
      flex-shrink: 0
      margin-left: 20px
  .but-cell
    width: 720px
    height: 822px
    background-image: url('../../assets/images/popularize/but-bg.png')
    background-size: 100%
    position: relative
    flex-shrink: 0
    .but
      width: 562px
      height: 90px
      background: linear-gradient(180deg, #FFFDFE 0%, #FFEBEC 100%)
      box-shadow: 0px 3px 20px rgba(247, 85, 64, 0.2)
      opacity: 1
      border-radius: 45px
      position: absolute
      bottom: 58px
      left: 50%
      transform: translateX(-50%)
      line-height: 90px
      text-align: center
      font-size: 42px
      color: #FE025C
      font-weight: bold
  .scroll-box
    width: 100%
    height: 95px
    margin: 10px auto
    overflow: hidden
    flex-shrink: 0
    .item
      font-size: 28px
      font-weight: bold
      color: #353535
      width: 100%
      text-align: center
      height: 95px
      line-height: 95px
  .line
    width: 635px
    height: 1px
    border-top: 1px dashed #6B4A4A
    margin-top: 10px
    flex-shrink: 0
  .title
    font-size: 32px
    font-weight: bold
    line-height: 50px
    margin: 30px 100px
    color: #6B4A4A
    text-align: center
    flex-shrink: 0
  .slide-enter-active,
  .slide-leave-active
    transition: all 0.5s linear

  .slide-leave-to
    transform: translateY(-45px)

  .slide-enter
    transform: translateY(45px)
  .desc
    padding: 0 .8rem .8rem .8rem
    flex-shrink: 0
    width: 100vw
    box-sizing: border-box
    overflow: hidden
  .dialog
    width: 100vw
    height: 100vh
    position: fixed
    z-index: 100
    left: 0
    top: 0
    opacity: 1
    background: rgba(0, 0, 0, 0.6)
    .content
      background-image: url('../../assets/images/popularize/coupon_success.png')
      background-size: 100%
      width: 552px
      height: 766px
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -70%)
      .coupon-info
        width: 460px
        height: 160px
        position: absolute
        left: 40px
        bottom: 246px
        display: flex
        flex-flow: row nowrap
        align-items: center
        .money
          color: #F0142D
          font-size: 48px
          font-weight: bold
          margin-left: 35px
          flex-shrink: 0
          .unit
            font-size: 30px
            font-weight: normal
        .right-cell
          display: flex
          flex-flow: column
          flex-grow: 1
          margin-left: 35px
          div
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
          .coupon-name
            font-size: 30px
            line-height: 60px
            color: #333333
            max-width: 266px
          .coupon-desc
            font-size: 26px
            line-height: 60px
            color: #F0142D
            max-width: 266px
      .but
        width: 484px
        height: 100px
        background: #ffffff
        border-radius: 50px
        font-size: 42px
        font-weight: bold
        line-height: 100px
        color: #FE0061
        text-align: center
        position: absolute
        bottom: 45px
        left: 34px
      .colse
        width: 64px
        height: 64px
        position: absolute
        left: 50%
        transform: translateX(-50%)
        bottom: -144px
  .dialog-hide
    display: none
    opacity: 0
  .no-start
    width: 100%
    text-align: center
    color: #FE025C
    padding: 180px 0 125px 0
    p
      font-size: 42px
      font-weight: bold
</style>
